var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel-main-template',{scopedSlots:_vm._u([{key:"page-title",fn:function(){return [_vm._v("Расписание")]},proxy:true},{key:"page-content",fn:function(){return [_c('schedule-calendar',{attrs:{"staff":_vm.staffList}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }